import _ from "lodash";
export default {
  templateOptions: [
    { value: "T1", text: "預設模板" },
    { value: "T2", text: "特製模版" },
    { value: "T3", text: "勞工個別健康指導單" }

  ],
  readonlyTemplateData: {
    patientName: { label: "patientName", key: "name" },
    patientId: { label: "patientId", key: "givenId" },
    dateOfBirth: { label: "dateOfBirth", key: "dateOfBirth" },
    departmentName: { label: "departmentName", key: "departmentName" },
    occupation: { label: "occupation", key: "occupation" },
    jobPosition: { label: "jobPosition", key: "jobPosition" },
    seniority: { label: "seniority", key: "seniority" },
  },
  normalTemplateData: {
    reason: { label: "reason", answer: "", rows: 5 },
    type: { label: "type", answer: "", rows: 5 },
    content: { label: "content", answer: "", rows: 5 },
    advice: { label: "advice", answer: "", rows: 5 },
    medicalHistory: { label: "medicalHistory", answer: "", rows: 5 },
    foodAllergyHistory: { label: "foodAllergyHistory", answer: "", rows: 5 },
    drugAllergyHistory: { label: "drugAllergyHistory", answer: "", rows: 5 },
    educationFood: { label: "educationFood", answer: [], rows: 5 },
    educationDisease: { label: "educationDisease", answer: [], rows: 5 },
    educationHabit: { label: "educationHabit", answer: [], rows: 5 },
    educationSpecial: { label: "educationSpecial", answer: [], rows: 5 },
    reasonNote: { label: "reasonNote", answer: "", rows: 5 },
    typeNote: { label: "typeNote", answer: "", rows: 5 },
    educationFoodNote: { label: "educationFoodNote", answer: "", rows: 5 },
    educationDiseaseNote: {
      label: "educationDiseaseNote",
      answer: "",
      rows: 5
    },
    educationHabitNote: { label: "educationHabitNote", answer: "", rows: 5 },
    educationSpecialNote: { label: "educationSpecialNote", answer: "", rows: 5 },
    unit: { label: 'unit', answer: '', rows: 5 },
    age: { label: 'age', answer: '', rows: 5 },
    seniority: { label: 'seniority', answer: '', rows: 5 },
    operatorType: { label: 'operatorType', answer: '', rows: 5 },
    operatorTypeNote: { label: 'operatorTypeNote', answer: '', rows: 5 },
    workTypeAndTime: { label: 'workTypeAndTime', answer: '', rows: 5 },
    smoke: { label: 'smoke', answer: '', rows: 5 },
    smokeNote: { label: 'smokeNote', answer: '', rows: 5 },
    betelNuts: { label: 'betelNuts', answer: '', rows: 5 },
    betelNutsNote: { label: 'betelNutsNote', answer: '', rows: 5 },
    drinking: { label: 'drinking', answer: '', rows: 5 },
    drinkingNote: { label: 'drinkingNote', answer: '', rows: 5 },
    sleepHour: { label: 'sleepHour', answer: '', rows: 5 },
    hasSpecialHazardousWork: { label: 'hasSpecialHazardousWork', answer: '', rows: 5 },
    specialHazardousWork1: { label: 'specialHazardousWork1', answer: '', rows: 5 },
    specialHazardousWork1Level: { label: 'specialHazardousWork1Level', answer: '', rows: 5 },
    specialHazardousWork2: { label: 'specialHazardousWork2', answer: '', rows: 5 },
    specialHazardousWork2Level: { label: 'specialHazardousWork2Level', answer: '', rows: 5 },
    specialHazardousWork3: { label: 'specialHazardousWork3', answer: '', rows: 5 },
    specialHazardousWork3Level: { label: 'specialHazardousWork3Level', answer: '', rows: 5 },
    specialHazardousWork4: { label: 'specialHazardousWork4', answer: '', rows: 5 },
    specialHazardousWork4Level: { label: 'specialHazardousWork4Level', answer: '', rows: 5 },
    specialHazardousWork5: { label: 'specialHazardousWork5', answer: '', rows: 5 },
    specialHazardousWork5Level: { label: 'specialHazardousWork5Level', answer: '', rows: 5 },
    personalPrivacy: { label: 'personalPrivacy', answer: false, row: 5 },
    personalMedicalHistory: { label: 'personalMedicalHistory', answer: '', rows: 5 },
    personalMedicalHistoryNote: { label: 'personalMedicalHistoryNote', answer: '', rows: 5 },
    familyMedicalHistory: { label: 'familyMedicalHistory', answer: '', rows: 5 },
    familyMedicalHistoryNote: { label: 'familyMedicalHistoryNote', answer: '', rows: 5 },
    isUseDrug: { label: 'isUseDrug', answer: '', row: 5 },
    isUseDrugNote: { label: 'isUseDrug', answer: '', row: 5 },
    healthcareManagement: { label: 'healthcareManagement', answer: '', row: 5 },
    healthcareExecute: { label: 'healthcareExecute', answer: [], row: 5 },
    healthcareYear: { label: 'healthcareYear', answer: '', row: 5 },
    healthcareOther: { label: 'healthcareOther', answer: '', row: 5 },
    unaidedVisualAcuityLeft: { label: 'unaidedVisualAcuityLeft', answer: '', row: 5 },
    correctedVisualAcuityLeft: { label: 'correctedVisualAcuityLeft', answer: '', row: 5 },
    unaidedVisualAcuityRight: { label: 'unaidedVisualAcuityRight', answer: '', row: 5 },
    correctedVisualAcuityRight: { label: 'correctedVisualAcuityRight', answer: '', row: 5 },
    height: { label: 'height', answer: '', row: 5 },
    weight: { label: 'weight', answer: '', row: 5 },
    waist: { label: 'waist', answer: '', row: 5 },

    bloodSugarBeforeMeals: { label: 'bloodSugarBeforeMeals', answer: '', row: 5 },
    hemoglobin: { label: 'hemoglobin', answer: '', row: 5 },
    whiteBloodCells: { label: 'whiteBloodCells', answer: '', row: 5 },

    urinaryProtein: { label: 'urinaryProtein', answer: '', row: 5 },
    urinaryOccultBlood: { label: 'urinaryOccultBlood', answer: '', row: 5 },
    glycosuria: { label: 'glycosuria', answer: '', row: 5 },

    alt: { label: 'alt', answer: '', row: 5 },
    creatinineCr: { label: 'creatinineCr', answer: '', row: 5 },

    totalCholesterol: { label: 'totalCholesterol', answer: '', row: 5 },
    triglycerides: { label: 'triglycerides', answer: '', row: 5 },
    lowDensityCholesterol: { label: 'lowDensityCholesterol', answer: '', row: 5 },
    highDensityCholesterol: { label: 'highDensityCholesterol', answer: '', row: 5 },

    systolicBloodPressureHealthCheck: { label: 'systolicBloodPressureHealthCheck', answer: '', row: 5 },
    diastolicBloodPressureHealthCheck: { label: 'diastolicBloodPressureHealthCheck', answer: '', row: 5 },
    pulseHealthCheck: { label: 'pulseHealthCheck', answer: '', row: 5 },
    systolicBloodPressure: { label: 'systolicBloodPressure', answer: '', row: 5 },
    diastolicBloodPressure: { label: 'diastolicBloodPressure', answer: '', row: 5 },
    pulse: { label: 'pulse', answer: '', row: 5 },
    xRayCheck: { label: 'xRayCheck', answer: '', row: 5 },
    nonRegulatoryItem: { label: 'nonRegulatoryItem', answer: '', row: 5 },
    riskLevel: { label: 'riskLevel', answer: '', row: 5 },
    workloadExecute: { label: 'workloadExecute', answer: '', row: 5 },
    followUpMeasures: { label: 'followUpMeasures', answer: '', row: 5 },
    framinghamRiskLevel: { label: 'framinghamRiskLevel', answer: '', row: 5 },
    iScoreLevel: { label: 'iScoreLevel', answer: '', row: 5 },
    jScoreLevel: { label: 'jScoreLevel', answer: '', row: 5 },
    overtimeHourLevel: { label: 'overtimeHourLevel', answer: '', row: 5 },
    jobTypeAssessmentLevel: { label: 'jobTypeAssessmentLevel', answer: '', row: 5 },
    cardiovascularDiseaseRiskLevel: { label: 'cardiovascularDiseaseRiskLevel', answer: '', row: 5 },

    ergonomicHazardsExecute: { label: 'ergonomicHazardsExecute', answer: '', row: 5 },
    ergonomicHazardsRiskLevel: { label: 'ergonomicHazardsRiskLevel', answer: '', row: 5 },
    ergonomicHazardsRiskNote: { label: 'ergonomicHazardsRiskNote', answer: '', row: 5 },
    ergonomicHazardsHighestSymptomSite: { label: 'ergonomicHazardsHighestSymptomSite', answer: '', row: 5 },
    ergonomicHazardsSymptomSiteList: { label: 'ergonomicHazardsSymptomSiteList', answer: '', row: 5 },
    ergonomicHazardsRiskReason: { label: 'ergonomicHazardsRiskReason', answer: '', row: 5 },

    maternalHealthProtectionExecute: { label: 'maternalHealthProtectionExecute', answer: '', row: 5 },
    pregnancyType: { label: 'pregnancyType', answer: '', row: 5 },
    maternalHealthProtectionLevel: { label: 'maternalHealthProtectionLevel', answer: '', row: 5 },
    maternalHealthProtectionNote: { label: 'maternalHealthProtectionNote', answer: '', row: 5 },
    preventionIllegalInfringementDutyExecute: { label: 'preventionIllegalInfringementDutyExecute', answer: '', row: 5 },
    preventionIllegalInfringementDutyNote: { label: 'preventionIllegalInfringementDutyNote', answer: '', row: 5 },
    laborHealthManagementExecute: { label: 'laborHealthManagement', answer: '', row: 5 },
    laborHealthManagementNote: { label: 'laborHealthManagementNote', answer: '', row: 5 },
    returnToWorkAssessmentExecute: { label: 'returnToWorkAssessmentExecute', answer: '', row: 5 },
    returnToWorkAssessmentNote: { label: 'returnToWorkAssessmentNote', answer: '', row: 5 },
    hasOtherNote: { label: 'hasOtherNote', answer: false, row: 5 },
    otherNote: { label: 'otherNote', answer: '', row: 5 },

    hasHealthGuidance: { label: 'hasHealthGuidance', answer: false, row: 5 },
    healthGuidance: { label: 'healthGuidance', answer: '', row: 5 },
    hasWorkPrecautionseNote: { label: 'hasWorkPrecautionseNote', answer: false, row: 5 },
    workPrecautionseNote: { label: 'workPrecautionseNote', answer: '', row: 5 },
    hasOtherMeasuresRecommendation: { label: 'hasOtherMeasuresRecommendation', answer: false, row: 5 },
    otherMeasuresRecommendation: { label: 'otherMeasuresRecommendation', answer: '', row: 5 },

    laborSigne: { label: 'laborSigne', answer: '', row: 5 },
    laborSigneDate: { label: 'laborSigneDate', answer: '', row: 5 },
    medicalStaffSigne: { label: 'medicalStaffSigne', answer: '', row: 5 },
    medicalStaffSigneDate: { label: 'medicalStaffSigneDate', answer: '', row: 5 }
  },
  fixTemplateData: {
    startConsultTime: { label: "startConsultTime", answer: "", rows: 5 },
    endConsultTime: { label: "endConsultTime", answer: "", rows: 5 },
    track: { label: "track", answer: "", rows: 5 },
    trackDate: { label: "trackDate", answer: "", rows: 5 },
    seniority: { label: "seniority", answer: "", rows: 5 }
  },
  templateFormDataOrder: [
    "reason",
    "type",
    "content",
    "advice",
    "medicalHistory",
    "foodAllergyHistory",
    "drugAllergyHistory",
    "educationFood",
    "educationFoodNote",
    "educationDiseaseNote",
    "educationHabitNote",
    "educationSpecialNote",
    "seniority"
  ],
  normalTemplateDataOption: {
    reason: [
      { value: "", text: "請選擇" },
      { value: "R1", text: "新進員工到職健康教育" },
      { value: "R2", text: "健康管理計畫衛教執行" },
      { value: "R3", text: "復工後適工性評估訪談" },
      { value: "R4", text: "年度健檢後醫療建議" },
      { value: "R5", text: "健康行為輔導矯正衛教" },
      { value: "R6", text: "防護具使用宣導衛教" },
      { value: "R7", text: "傷病後健康關懷衛教" },
      { value: "other", text: "其他" }
    ],
    type: [
      { value: "", text: "請選擇" },
      { value: "T1", text: "面談" },
      { value: "T2", text: "電話訪問" },
      { value: "T3", text: "電子信箱" },
      { value: "other", text: "其他" }
    ],
    educationFood: [
      { value: "F1", text: "低膽固醇飲食" },
      { value: "F2", text: "低熱量飲食" },
      { value: "F3", text: "痛風飲食" },
      { value: "other", text: "其他" }
    ],
    educationDisease: [
      { value: "D1", text: "高血壓" },
      { value: "D2", text: "高血脂" },
      { value: "D3", text: "糖尿病" },
      { value: "D4", text: "肝炎" },
      { value: "other", text: "其他" }
    ],
    educationHabit: [
      { value: "H1", text: "戒檳手冊" },
      { value: "H2", text: "戒菸手冊" },
      { value: "H3", text: "減重手冊" },
      { value: "other", text: "其他" }
    ],
    educationSpecial: [
      { value: "S1", text: "聽力保護" },
      { value: "S2", text: "如何正確佩帶噪音防護具" },
      { value: "other", text: "其他" }
    ],
    track: [
      { value: "close", text: "結案" },
      { value: "track", text: "追蹤" }
    ],
    operatorType: [
      { value: "O1", text: "行政人員" },
      { value: "O2", text: "現場操作人員" },
      { value: "other", text: "其他" }
    ],
    smoke: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    betelNuts: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    drinking: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    hasSpecialHazardousWork: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    specialHazardousWork: [
      { value: "", text: "請選擇" },
      { value: '1', text: '高溫' },
      { value: '2', text: '噪音' },
      { value: '3', text: '游離輻射' },
      { value: '4', text: '異常氣壓' },
      { value: '5', text: '鉛' },
      { value: '6', text: '四烷基鉛' },
      { value: '7', text: '四氯乙烷' },
      { value: '8', text: '四氯化碳' },
      { value: '9', text: '二硫化碳' },
      { value: '10', text: '三氯乙烯、四氯乙烯' },
      { value: '11', text: '二甲基甲醯胺' },
      { value: '12', text: '正己烷' },
      { value: '13', text: '聯苯胺及其鹽類等' },
      { value: '14', text: '鈹' },
      { value: '15', text: '氯乙烯' },
      { value: '16', text: '苯' },
      { value: '17', text: '二異氰酸甲苯等' },
      { value: '18', text: '石綿' },
      { value: '19', text: '砷' },
      { value: '20', text: '錳' },
      { value: '21', text: '黃磷' },
      { value: '22', text: '聯吡啶或巴拉刈' },
      { value: '23', text: '粉塵' },
      { value: '24', text: '鉻酸及其鹽類' },
      { value: '25', text: '鎘' },
      { value: '26', text: '鎳' },
      { value: '27', text: '乙基汞、汞' },
      { value: '28', text: '溴丙烷' },
      { value: '29', text: '1,3-丁二烯' },
      { value: '30', text: '甲醛' },
      { value: '31', text: '銦' },
      { value: '32', text: '汞及無機化合物' }],
    specialHazardousWorkLevel: [
      { value: "", text: "請選擇" },
      { value: '1', text: '一級' },
      { value: '2', text: '二級' },
      { value: '3', text: '三級' },
      { value: '4', text: '四級' },
    ],
    personalMedicalHistory: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    familyMedicalHistory: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    isUseDrug: [
      { value: 'no', text: '無' },
      { value: 'yes', text: '有' },
    ],
    healthcareManagement: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    healthcareExecute: [
      { value: 'new', text: '新人' },
      { value: 'specialHazardousWork', text: '特別危害健康作業' },
      { value: 'year', text: '年度' },
      { value: 'otherReason', text: '其他' },
    ],
    riskLevel: [
      { value: '1', text: '一級' },
      { value: '2', text: '二級' },
      { value: '3', text: '三級' },
      { value: '4', text: '四級' },
    ],
    workloadExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    followUpMeasures: [
      { value: 'no', text: '否' },
      { value: 'yes', text: '是' },
      { value: 'suggestion', text: '建議面談' },
    ],
    framinghamRiskLevel: [
      { value: '0', text: '低' },
      { value: '1', text: '中' },
      { value: '2', text: '高' },
      { value: '3', text: '極高' },
    ],
    iScoreLevel: [
      { value: '0', text: '低' },
      { value: '1', text: '中' },
      { value: '2', text: '高' },
    ],
    jScoreLevel: [
      { value: '0', text: '低' },
      { value: '1', text: '中' },
      { value: '2', text: '高' },
    ],
    overtimeHourLevel: [
      { value: '0', text: '低' },
      { value: '1', text: '中' },
      { value: '2', text: '高' },
    ],
    jobTypeAssessmentLevel: [
      { value: '0', text: '低' },
      { value: '1', text: '中' },
      { value: '2', text: '高' },
    ],
    cardiovascularDiseaseRiskLevel: [
      { value: '0', text: '０' },
      { value: '1', text: '１' },
      { value: '2', text: '２' },
      { value: '3', text: '３' },
      { value: '4', text: '４' },
    ],
    ergonomicHazardsExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    ergonomicHazardsRiskLevel: [
      { value: 'E1', text: '無危害' },
      { value: 'E2', text: '疑似有危害' },
      { value: 'E3', text: '有危害' },
    ],
    maternalHealthProtectionExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    pregnancyType: [
      { value: 'P1', text: '孕期中' },
      { value: 'P2', text: '產後' },
    ],
    maternalHealthProtectionLevel: [
      { value: '0', text: '無' },
      { value: '1', text: '一級' },
      { value: '2', text: '二級' },
      { value: '3', text: '三級' },
    ],
    preventionIllegalInfringementDutyExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    laborHealthManagementExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
    returnToWorkAssessmentExecute: [
      { value: 'yes', text: '本次執行' },
      { value: 'no', text: '本次沒執行' },
    ],
  },
  templateSettings: {
    T1: {
      patientName: true,
      patientId: true,
      dateOfBirth: true,
      departmentName: true,
      occupation: true,
      jobPosition: true,
      seniority: true,
      medicalHistory: true,
      foodAllergyHistory: true,
      drugAllergyHistory: true,
      reason: true,
      type: true,
      content: true,
      advice: true,
      educationFood: true,
      educationDisease: true,
      educationHabit: true,
      educationSpecial: true,
      trackDate: true,
    },
    T2: {
      patientName: true,
      patientId: true,
      dateOfBirth: true,
      departmentName: true,
      occupation: true,
      jobPosition: true,
      seniority: false,
      medicalHistory: true,
      foodAllergyHistory: true,
      drugAllergyHistory: true,
      reason: true,
      type: true,
      content: true,
      advice: false,
      educationFood: true,
      educationDisease: true,
      educationHabit: true,
      educationSpecial: true,
      trackDate: true,
    },
    T3: {
      patientName: true,
      patientId: true,
      dateOfBirth: true,
      departmentName: true,
      seniority: true,
      unit: true,
      age: true,
      operatorType: true,
      operatorTypeNote: true,
      workTypeAndTime: true,
      smoke: true,
      smokeNote: true,
      betelNuts: true,
      betelNutsNote: true,
      drinking: true,
      drinkingNote: true,
      sleepHour: true,
      hasSpecialHazardousWork: true,
      specialHazardousWork1: true,
      specialHazardousWork1Level: true,
      specialHazardousWork2: true,
      specialHazardousWork2Level: true,
      specialHazardousWork3: true,
      specialHazardousWork3Level: true,
      specialHazardousWork4: true,
      specialHazardousWork4Level: true,
      specialHazardousWork5: true,
      specialHazardousWork5Level: true,
      personalPrivacy: true,
      personalMedicalHistory: true,
      personalMedicalHistoryNote: true,
      familyMedicalHistory: true,
      familyMedicalHistoryNote: true,
      isUseDrug: true,
      isUseDrugNote: true,
      healthcareManagement: true,
      healthcareExecute: true,
      healthcareYear: true,
      healthcareOther: true,
      unaidedVisualAcuityLeft: true,
      correctedVisualAcuityLeft: true,
      unaidedVisualAcuityRight: true,
      correctedVisualAcuityRight: true,
      height: true,
      weight: true,
      waist: true,
      bloodSugarBeforeMeals: true,
      hemoglobin: true,
      whiteBloodCells: true,
      urinaryProtein: true,
      urinaryOccultBlood: true,
      glycosuria: true,
      alt: true,
      creatinineCr: true,
      totalCholesterol: true,
      triglycerides: true,
      lowDensityCholesterol: true,
      highDensityCholesterol: true,
      systolicBloodPressureHealthCheck: true,
      diastolicBloodPressureHealthCheck: true,
      pulseHealthCheck: true,
      systolicBloodPressure: true,
      diastolicBloodPressure: true,
      pulse: true,
      xRayCheck: true,
      nonRegulatoryItem: true,
      chestXRay: true,
      riskLevel: true,
      workloadExecute: true,
      followUpMeasures: true,
      framinghamRiskLevel: true,
      iScoreLevel: true,
      jScoreLevel: true,
      overtimeHourLevel: true,
      jobTypeAssessmentLevel: true,
      cardiovascularDiseaseRiskLevel: true,
      ergonomicHazardsExecute: true,
      ergonomicHazardsRiskLevel: true,
      ergonomicHazardsRiskNote: true,
      ergonomicHazardsHighestSymptomSite: true,
      ergonomicHazardsSymptomSiteList: true,
      ergonomicHazardsRiskReason: true,
      maternalHealthProtectionExecute: true,
      pregnancyType: true,
      maternalHealthProtectionLevel: true,
      maternalHealthProtectionNote: true,
      preventionIllegalInfringementDutyExecute: true,
      preventionIllegalInfringementDutyNote: true,
      laborHealthManagementExecute: true,
      laborHealthManagementNote: true,
      returnToWorkAssessmentExecute: true,
      returnToWorkAssessmentNote: true,
      hasOtherNote: true,
      otherNote: true,
      healthGuidance: true,
      workPrecautionseNote: true,
      otherMeasuresRecommendation: true,
      laborSigne: true,
      laborSigneDate: true,
      medicalStaffSigne: true,
      medicalStaffSigneDate: true,
      hasHealthGuidance: true,
      hasWorkPrecautionseNote: true,
      hasOtherMeasuresRecommendation: true,
    }
  },
  getTemplateName(templateId) {
    let name = "";

    this.templateOptions.forEach(option => {
      if (option.value == templateId) {
        name = option.text;
      }
    });

    return name;
  },
  hasTemplateId(templateId) {
    let isExist = false;

    this.templateOptions.forEach(option => {
      if (option.value == templateId) {
        isExist = true;
      }
    });

    return isExist;
  },
  getInitFormData(templateId) {
    let formData = {};
    if (this.hasTemplateId(templateId)) {
      Object.keys(this.normalTemplateData).forEach(field => {
        if (this.templateSettings[templateId][field]) {
          formData[field] = JSON.parse(
            JSON.stringify(this.normalTemplateData[field])
          );
          if (
            this.normalTemplateDataOption[field] &&
            this.normalTemplateDataOption[field].filter(
              option => option.value == "other"
            ).length > 0
          ) {
            formData[`${field}Note`] = JSON.parse(
              JSON.stringify(this.normalTemplateData[`${field}Note`])
            );
          }
        }
      });
      Object.keys(this.fixTemplateData).forEach(field => {
        formData[field] = JSON.parse(
          JSON.stringify(this.fixTemplateData[field])
        );
      });
    }

    return formData;
  },
  getInitFormDataOrder(templateId) {
    let formDataOrder = [];
    if (this.hasTemplateId(templateId)) {
      formDataOrder = this.templateFormDataOrder.filter(
        field => this.templateSettings[templateId][field]
      );
      formDataOrder = formDataOrder.concat(Object.keys(this.fixTemplateData));
    }

    return formDataOrder;
  },
  getReadonlyFormData(templateId) {
    let formDataList = [];

    if (this.hasTemplateId(templateId)) {
      Object.keys(this.readonlyTemplateData).forEach(field => {
        if (this.templateSettings[templateId][field]) {
          formDataList.push(
            JSON.parse(JSON.stringify(this.readonlyTemplateData[field]))
          );
        }
      });
    }

    return formDataList;
  },
  getFormDataOptions(field) {
    let options = [];
    if (Object.keys(this.normalTemplateDataOption).includes(field)) {
      options = JSON.parse(
        JSON.stringify(this.normalTemplateDataOption[field])
      );
    }
    return options;
  },
  getEducationTypeList() {
    return [
      "educationFood",
      "educationDisease",
      "educationHabit",
      "educationSpecial"
    ];
  },
  reportDisplayFuncton: {
    betelNutAnswerDispaly(data) {
      if (data && data.items) {
        //fuan display
        const findBeteNutItem = data.items.find(
          item => item.questionLabel === "betelNut"
        );
        if (!_.isUndefined(findBeteNutItem)) {
          const answer = findBeteNutItem.answers[0].answer[0];
          const answerValues = findBeteNutItem.answers[0].answerValues[0];
          if (answer === "已戒") {
            return `${answer},${answerValues}年`;
          } else if (answer === "有") {
            return `${answer},${answerValues}顆/天`;
          } else if (answer === "無") {
            return answer;
          }
        }
      }

      return "";
    },
    alcoholAnswerDisplay(data) {
      if (data && data.items) {
        //fuan display
        const item = data.items.find(item => item.questionLabel === "alcohol");
        if (!_.isUndefined(item)) {
          const answer = item.answers[0].answer[0];
          const answerValues = item.answers[0].answerValues[0];
          if (answer === "已戒") {
            return `${answer},${answerValues}年`;
          } else if (answer === "有") {
            if (answerValues === "Greater") {
              return `${answer},大於10杯/天`;
            }
            return `${answer},${answerValues}杯/天`;
          } else if (answer === "無") {
            return answer;
          }
        }
      }
      return "";
    },
    travelHistoryDisplay(data) {
      if (data && data.items) {
        //fuan display
        const item = data.items.find(
          item => item.questionLabel === "travelHistory"
        );
        if (!_.isUndefined(item)) {
          const answer = item.answers[0].answer[0];
          const answerValues = item.answers[0].answerValues;
          if (answer === "有") {
            return `${answer},國家:${answerValues[0]},起始日期:${answerValues[1]},結束日期:${answerValues[2]}`;
          } else if (answer === "無") {
            return answer;
          }
        }
      }
      return "";
    },
    allergyHistoryDisplay(data) {
      if (data && data.items) {
        //fuan display
        const item = data.items.find(
          item => item.questionLabel === "allergyHistory"
        );
        if (!_.isUndefined(item)) {
          const answers = item.answers;
          let answersArray = [];
          answers.forEach(answer => {
            if (answer.answer[0] === "無") {
              answersArray.push(answer.answer[0]);
            } else {
              const answerValues = answer.answerValues.filter(
                value => value != answer.answer[0]
              );
              answersArray.push(`${answer.answer[0]}:${answerValues}`);
            }
          });

          if (answersArray.length > 0) {
            return answersArray.join(",");
          }
        }
      }
      return "";
    },
    nmqDisplay(data) {
      const keyArray = [
        "q1",
        "q2",
        "q3",
        "q4",
        "neck",
        "leftShoulder",
        "rightShoulder",
        "upperBack",
        "lowerBack",
        "leftArm",
        "rightArm",
        "leftWrist",
        "rightWrist",
        "leftTight",
        "rightTight",
        "leftKnee",
        "rightKnee",
        "leftAnkle",
        "rightAnkle",
        "other",
        "description"
      ];
      let returnObj = {};
      keyArray.forEach(key => {
        if (_.has(data, key)) {
          returnObj = {
            ...returnObj,
            [key]: _.isEmpty(data[key]) ? "無不適" : data[key]
          };
        }
      });

      return returnObj;
    }
  }
};
